/** Expands a 32-bit seed into a generator state (splitmix32) and warms the generator up. */
export function seedRng(seed) {
    let s = seed >>> 0;
    const next = () => {
        s = (s + 0x9e3779b9) | 0;
        let t = s ^ (s >>> 16);
        t = Math.imul(t, 0x21f0aaad);
        t ^= t >>> 15;
        t = Math.imul(t, 0x735a2d97);
        return (t ^ (t >>> 15)) | 0;
    };
    const state = [next(), next(), next(), next()];
    for (let i = 0; i < 15; i++)
        rngU32(state);
    return state;
}
export function cloneRng(state) {
    return [state[0], state[1], state[2], state[3]];
}
/** Advances the generator in place and returns a uniform unsigned 32-bit integer. */
export function rngU32(state) {
    const a = state[0] | 0;
    const b = state[1] | 0;
    const c = state[2] | 0;
    const d = state[3] | 0;
    const t = (((a + b) | 0) + d) | 0;
    state[3] = (d + 1) | 0;
    state[0] = b ^ (b >>> 9);
    state[1] = (c + (c << 3)) | 0;
    const rotated = (c << 21) | (c >>> 11);
    state[2] = (rotated + t) | 0;
    return t >>> 0;
}
/** Uniform in [0, 1). */
export function rngFloat(state) {
    return rngU32(state) / 4294967296;
}
/** Uniform in [min, max). */
export function rngRange(state, min, max) {
    return min + (max - min) * rngFloat(state);
}
/** Uniform integer in [0, n). */
export function rngInt(state, n) {
    return Math.floor(rngFloat(state) * n);
}
/** Uniform in [-1, 1). */
export function rngSigned(state) {
    return rngFloat(state) * 2 - 1;
}
/** Bell-shaped in (-1, 1) (mean of three uniforms); used for aim noise. */
export function rngBell(state) {
    return (rngSigned(state) + rngSigned(state) + rngSigned(state)) / 3;
}
/** True with probability `p`. */
export function rngChance(state, p) {
    return rngFloat(state) < p;
}
//# sourceMappingURL=rng.js.map